import { H1, PrimaryButton, SecondaryButton } from "@itpi/react-components";
import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Page } from "../components/Page";
import AuthContext from "../context/AuthContext";
import { GetSelfAssessments } from "../data/QuestionApi";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DescriptionIcon from "@material-ui/icons/Description";
import "../assets/Dashboard.scss";

export const BaseURL = `${process.env.REACT_APP_API_BASE_URL}/entrecomp`;

export const Dashboard: React.FC<{}> = () => {
  const { token } = useContext(AuthContext);
  const [selfAssessments, setSelfAssessments] = useState<any>([]);

  useEffect(() => {
    GetSelfAssessments(token).then((result) => setSelfAssessments(result));
  }, [token]);

  const compare = (a: any, b: any) => {
    return (
      new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime()
    );
  };

  selfAssessments.sort(compare);

  const dateReadable = (date: Date) => {
    return new Date(date).toLocaleString().replace(",", "");
  };

  return (
    <Page>
      <div style={{ alignContent: "baseline", display: "flex" }}>
        <H1 style={{ fontSize: 22 }}>Self Assessments</H1>
        <Link to="/selfassessment">
          <PrimaryButton style={{ flexGrow: 0, marginLeft: 10 }}>
            New{" "}
          </PrimaryButton>
        </Link>
        <Link to="">
          <SecondaryButton style={{ flexGrow: 0, marginLeft: 5}}>
            Home{" "}
          </SecondaryButton>
        </Link>
      </div>

      {selfAssessments.map((assessment: any) => {
        return (
          <div className="ListItem">
            <ListItem
              component={Link}
              to={`/result/${assessment.id}`}
              button
              style={{ borderRadius: 15 }}
            >
              <div className="Icon">
                <ListItemIcon>
                  <DescriptionIcon
                    fontSize="large"
                    style={{ color: "#c26763" }}
                  />
                </ListItemIcon>
              </div>
              <div className="Text">
                <ListItemText primary={dateReadable(assessment.dateCreated)} />
              </div>
            </ListItem>
          </div>
        );
      })}
    </Page>
  );
};
